module.exports = __webpack_public_path__ + "files/aeaebedf7aa15330657397b10236c901.png";